import { Component, Input } from '@angular/core';
import {
  AyaProgressPhase,
  AyaSearchStep,
} from 'src/app/core/utils/aya-progress.util';

@Component({
  selector: 'app-aya-chat-progress',
  templateUrl: './aya-chat-progress.component.html',
  styleUrls: ['./aya-chat-progress.component.scss'],
})
export class AyaChatProgressComponent {
  @Input() phases: AyaProgressPhase[] = [];
  @Input() searchSteps: AyaSearchStep[] = [];
  @Input() statusLine: string | null = null;
  @Input() isActive = false;
  @Input() showSearchSteps = true;

  /** Collapsed by default — user expands (matches Ask Aya ProgressAccordion). */
  open = false;

  get hasContent(): boolean {
    return (
      this.phases.length > 0 ||
      (this.showSearchSteps && this.searchSteps.length > 0) ||
      Boolean(this.statusLine)
    );
  }

  get activeLabel(): string {
    const active = this.phases.find((p) => p.state === 'active');
    const status = this.statusLine?.trim() || null;
    return (
      active?.label ??
      status ??
      (this.isActive ? 'Working…' : 'Done')
    );
  }

  get showSearchList(): boolean {
    const searching = this.phases.find((p) => p.key === 'searching');
    return (
      this.showSearchSteps &&
      this.searchSteps.length > 0 &&
      searching?.state !== 'skipped'
    );
  }

  toggle(): void {
    this.open = !this.open;
  }
}
